module.exports = {
      id: "copy-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#copy",
      toString: function () {
        return this.url;
      }
    }